export const types = {
  SET_EDITABLE_BLOCK_PAGE_INFO: 'SET_EDITABLE_BLOCK_PAGE_INFO',
  RESET_BLOCK_PAGE_EDIT_FORM_DATA: 'RESET_BLOCK_PAGE_EDIT_FORM_DATA',
  SET_VALIDATION_BLOCK_PAGE_INFO: 'SET_VALIDATION_BLOCK_PAGE_INFO',
  UPDATE_BLOCK_PAGE_INFO: 'UPDATE_BLOCK_PAGE_INFO',
};

export const RESPONSE_ROW_COUNT = 5;
export const RESPONSE_MAX_LEN = 1000;
